import React from "react";

const LoadingSpinner = () => {
  return (
    <div className="w-5 h-5 border-2 border-white rounded-full border-t-transparent animate-spin" />
  );
};

export default LoadingSpinner;
